import axios from "axios";

// import {
//   SupportedChainId,
//   SUPPORTED_NETWORKS,
//   TESTNET_NETWORKS,
// } from "constants/chains";
// import { checkSum, initalizeWeb3 } from "./utils";
import { ETHERSCAN_API_KEY, nftTempImage } from "../constants";
import { dummyTokenImage, ethLogo } from "../assets";
import { Erc20ABI } from "../contract/abis/Erc20ABI";
import Web3 from "web3";

const SupportedChainId = {
  ETHEREUM_MAINNET: 1,
  ETHEREUM_GOERLI: 5,
};

export const SUPPORTED_NETWORKS = {
  [SupportedChainId.ETHEREUM_GOERLI]: {
    name: "goerli",
    chainId: "0x5",
    contractAddress: "0x1F7A5881014e408f22A3D42C50bcB27D8C969eEC",
    rpc: `https://rpc.ankr.com/eth_goerli/f064a0dd6d0f195e4a1f62d9d9dae9f45f93bdcf85fa8cb854c5df64b8ecafa1`,
    api: "https://api-goerli.etherscan.io/api",
    api_key: "M193VGUECIDFKWVWAJA9ZPQNKBANY9613B",
    symbol: "ETH",
    coingeckoId: "ethereum",
    icon: ethLogo,
  },
};

export const TESTNET_NETWORKS = [5];
export const MAINNET_NETWORKS = [1];

export const initalizeWeb3 = (activeNetwork) => {
  const web3 = new Web3(SUPPORTED_NETWORKS[activeNetwork].rpc);

  return web3;
};

export const checkSum = (address) => {
  if (!address) return address;
  if (!Web3.utils.isAddress(address)) return address;
  return Web3.utils.toChecksumAddress(address);
};

export const fetchMainnetHoldings = async (address, network) => {
  const { data } = await axios.post("https://rpc.ankr.com/multichain", {
    jsonrpc: "2.0",
    method: "ankr_getAccountBalance",
    params: {
      blockchain: "eth",
      walletAddress: address,
    },
    id: 1,
  });
  console.log(data.result);

  return data.result;
};

export const fetchTestnetHoldings = async (address, network) => {
  try {
    console.log("address, network 111111", address, network);
    // 0x7431310e026B69BFC676C0013E12A1A11411EEc9
    const web3 = initalizeWeb3(network);
    const url = SUPPORTED_NETWORKS[network].api;
    const key = SUPPORTED_NETWORKS[network].api_key;

    const obj = {};
    let erc20 = [];

    console.log("address, network", address, network);

    const { data } = await axios.get(
      `${url}?module=account&action=tokentx&address=${address}&sort=asc&apikey=${key}`
    );

    const result = data.result.slice(0, 500);

    console.log("res", result);
    if (result.length > 0 && result && Array.isArray(result)) {
      console.log("mark1", result);
      erc20 = await Promise.all(
        result?.map(async (res) => {
          if (!obj[res.contractAddress]) {
            obj[res.contractAddress] = {
              tokenName: res.tokenName,
              tokenSymbol: res.tokenSymbol,
              tokenDecimal: res.tokenDecimal,
              contractAddress: checkSum(res.contractAddress),
            };

            console.log("mark2", obj);

            const contract = new web3.eth.Contract(
              Erc20ABI.abi,
              res.contractAddress
            );

            console.log("mark3", contract);

            const tokenBalance = await contract.methods
              .balanceOf(address)
              .call();

            console.log("mark4", tokenBalance);

            console.log("tokenBalance", tokenBalance);
            if (Number(tokenBalance) && res.tokenName) {
              return {
                id: checkSum(res.contractAddress),
                tokenName: res.tokenName,
                tokenSymbol: res.tokenSymbol,
                tokenBalance:
                  Number(tokenBalance) / 10 ** Number(res.tokenDecimal),
                tokenBalanceRawInteger: tokenBalance,
                tokenAddress: checkSum(res.contractAddress),
                tokenDecimal: +res.tokenDecimal,
                priceInUSD:
                  1 * (Number(tokenBalance) / 10 ** Number(res.tokenDecimal)),
                image: dummyTokenImage,
                tokenPrice: 1, //! get coingeckoid to get token price is usd for testnet tokens
                allocation: 0,
              };
            }
          }
        })
      );

      console.log("erc20", erc20);
      let filtered = [];

      erc20?.forEach((token) => {
        if (token) {
          filtered.push(token);
        }
      });
      if (filtered.length > 15) {
        filtered = filtered.splice(0, 12);
      }

      return filtered;
    } else {
      return {};
    }
  } catch (error) {
    console.log("error in fetching holding", error);
  }
};

export const fetchUserHoldings = async (address, network) => {
  if (TESTNET_NETWORKS.includes(network)) {
    const data = await fetchTestnetHoldings(address, network);
    console.log("testnet", data);
    return data;
  } else {
    const data = await fetchMainnetHoldings(address, network);
    console.log("mainnet", data);
    return data;
  }
};
